import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, Container } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';

import nav1 from '../../assets/image-nav-1.png'
import nav2 from '../../assets/image-nav-2.png'

import CardActionArea from '@material-ui/core/CardActionArea';

import ShoppingBasketOutlined from '@material-ui/icons/ShoppingBasketOutlined';
import AttachMoneyOutlined from '@material-ui/icons/AttachMoneyOutlined';
import DescriptionOutlined from '@material-ui/icons/DescriptionOutlined';
import InfoOutlined from '@material-ui/icons/InfoOutlined';

import moment from 'moment'
import Parse from 'parse';
import { getFromAPI } from '../helpers/sqlApiCalls';
import Publication from '../../components/Publication';

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 180,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: theme.spacing(2),
    },
    bgDg: {
        width: '100%',
        position: 'absolute',
        left: 0,
        height: 200,
        top: 64
    },
    textWhite1: {
        color: "#fff",
        fontSize: 25, fontWeight: 500
    },
    textWhite2: {
        color: "#fff",
        fontSize: 15, fontWeight: 300
    }, bgimg: {
        width: '100%',
        position: 'absolute',
        left: 0,
        minWidth: '100%',
        top: 64,
        height: 200
    },
    bgimg2: {
        // background: "rgb(0,0,0)",
        // background: "linear-gradient(180deg, rgba(0,0,0,0.7113620448179272) 62%, rgba(0,0,0,0) 100%)",
        width: '100%',
        minWidth: '100%',
        position: 'absolute',
        left: 0,
        top: 64,
        height: 200
    },
    iconStyles: {
        color: theme.palette.nav.actions,
        fontSize: 40
    },
    spinner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh'
    },
    textBtn: {
        border: 'none',
        backgroundColor: 'inherit',
        color: '#0f5591', 
        fontSize: 16,
        cursor: 'pointer'
      }   
}));



function Nav2(props) {
    const { changeView } = props;
    const spacing = 2;
    const classes = useStyles();
    const [pedidosprogress, setPedidos1] = useState(0)
    const [pedidosend, setPedidos2] = useState(0)
    const [saldo, setSaldo] = useState(0)
    const [atraso, setAtraso] = useState(0)
    const [news, setNews] = useState([])
    const [loadingImages, setLoadingImages] = useState(true)

    const user = JSON.parse(localStorage.user)

    useEffect(() => {
        // Run! Like go get some data from an API.
        var GameScore = Parse.Object.extend("Orders");
        var query1 = new Parse.Query(GameScore);
        var query2 = new Parse.Query(GameScore);

        query1.equalTo('envId', localStorage.env)
        query2.equalTo('envId', localStorage.env)
        query1.equalTo('or', 2)
        query2.equalTo('or', 2)
        query1.greaterThan('cfost', localStorage.client + "true" + 0 + localStorage.sellerCode + "1297043591000")
            .lessThan('cfost', localStorage.client + "true" + 0 + localStorage.sellerCode + Date.now())
            .greaterThan('te', Date.now() - (1000 * 60 * 60 * 24 * 8) - 1) // pedidos que se cargaron en los ultimos 7 dias
        query2.greaterThan('cfost', localStorage.client + "true" + 0 + localStorage.sellerCode + "1297043591000")
            .lessThan('te', Date.now() - ((1000 * 60 * 60 * 24 * 8) - 1)) // pedidos que se cargaron hace mas de 7 dias
            .lessThan('cfost', localStorage.client + "true" + 0 + localStorage.sellerCode + Date.now())
        query1.equalTo('s', 2)
        query2.equalTo('s', 2)

        query1.count().then((x) => {
            setPedidos1(x)
        });
        query2.count().then((x) => {
            setPedidos2(x)
        });


        const getCurrentAccount = async () => {
            // generamos una fecha en milisegundos de 90 dias atras desde hoy
            // let past = new Date();
            // past.setDate(past.getDate() - 90);
            // past = Date.parse(past)

            let first = "rawQueries=c='" + localStorage.client + "' AND "
            let second = "tc>1295300399099 AND tc<" + Date.now()
            let third = " AND deletedAt is null"
            let fourth = " ORDER BY te DESC"

            let ccaQuery = first + second + third + fourth

            const cuentaCorriente = await getFromAPI(
                "CurrentAccount",
                ccaQuery,
                120000,
                true
            )

            let saldoComprobante = 0
            let fecha = Date.now()

            const rowres = []

            const createData = (code, date, dueDate, cuenta, amount, pending, overdue, status, data, id, k2) => {
                return { code, date, dueDate, cuenta, amount, pending, overdue, status, data, id, k2 };
            }

            const a2 = moment()

            for (let element of cuentaCorriente) {

                let montoOriginal = 0
                let saldo = 0
                if (element.q) {
                    for (let cuota of Object.values(element.q)) {
                        montoOriginal = +cuota.ia
                        saldo = +cuota.ia - +cuota.pa
                    }
                }

                saldoComprobante += (+saldo)
                if (element.te < fecha) {
                    fecha = element.te
                }
                const a3 = moment(element.te)
                const diff = a2.diff(a3, 'days')
                rowres.push(
                    createData(
                        (element.dc + "-" + element.do + "-" + element.dn),
                        moment(element.tc).format('DD/MM/YYYY'),
                        moment(element.te).format('DD/MM/YYYY'),
                        element.cuenta,
                        '$ ' + parseFloat(montoOriginal).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
                        '$ ' + parseFloat(saldo).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
                        (diff < 0 ? 0 : diff),
                        element.s === 1 ? ('En Proceso') : ('Facturado'),
                        element,
                        element.id, element.k2))

            }
            localStorage.historialCobranzas = JSON.stringify(rowres)
            const a1 = moment(fecha)
            const diff2 = a2.diff(a1, 'days')
            setSaldo(parseFloat(saldoComprobante).toFixed(2))
            localStorage.saldo = saldoComprobante + ""
            localStorage.atraso = diff2 + ""
            setAtraso(diff2)
        }

        const getNews = async () => {
            const news = Parse.Object.extend('News')

            const query0 = new Parse.Query(news);
            query0.equalTo('envId', localStorage.env).equalTo('d', 2).lessThan('sd', Date.now()).greaterThan('ed', Date.now()).doesNotExist('deletedAt');

            const query1 = new Parse.Query(news);
            query1.equalTo('envId', localStorage.env).equalTo('d', 2).lessThan('sd', Date.now()).doesNotExist('ed').doesNotExist('deletedAt');

            const query = Parse.Query.or(query0, query1);

            const response = await query.find();
            if (response) {
                let arr = [];
                for (let i in response) {
                    let includeObj = true;
                    if (includeObj) {
                        arr.push({ ...response[i].attributes, id: response[i].id })
                    }
                }
                setNews(arr)
            }
            setLoadingImages(false)

        }
        getNews()
        getCurrentAccount()
    }, []);
    // const bull = <span className={classes.bullet}>•</span>;
    return (
        <div>
            {   
                user.k == "" || user.k == undefined || user.k == null ?
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center", heigth: 0, marginTop: 110}}>
                  <p style={{
                    padding: 0,
                    backgroundColor: "inherit",
                    color: "#a2a2a2",
                    fontSize: 16
                    }}>
                      El usuario actual esta pendiente de aprobación, complete la documentación necesaria 
                  </p>
                  <button
                    className={classes.textBtn}
                    onClick={
                        () => changeView(6, 3)
                    }
                  >
                     aquí.
                  </button>
                </div>
                    : null

                
                        
            }
            <Container style={{ display: 'flex', flexWrap: 'wrap', paddingTop: 20, marginTop: user.k == "" || user.k == undefined || user.k == null ? 0 : 88}} >
            <div style={{ flex: 1, margin: '0.5rem' }}>
            {
                loadingImages ?
                    <div className={classes.spinner}>
                        <CircularProgress />
                    </div>
                    :
                    news.length > 0 ?
                        <React.Fragment>
                            {news.map((value) => {
                                return <Publication key={value.id} news={value} />;
                            })}
                        </React.Fragment>
                        :
                        <div className={classes.spinner}>
                            <p>No hay novedades</p>
                        </div>
            }
            </div>
            <div style={{ flex: 1, margin: '0.5rem' }} >
            <Typography style={{ fontSize: 18, fontWeight: 500, paddingBottom: 15 }}>
                Accesos Directos
            </Typography>
            <Grid container className={classes.root} spacing={2}>
                <Grid container spacing={spacing}>
                    {/* <Grid item xs={12} sm={6}>
                        <Card className={classes.root}>
                            <CardActionArea onClick={() => changeView(0, 2)} >
                                <CardContent>
                                    <ShoppingBasketOutlined className={classes.iconStyles} ></ShoppingBasketOutlined>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>

                                    </Typography>
                                    <Typography style={{ fontSize: 20 }}>
                                        Pedidos
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        En proceso: {pedidosprogress}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        Finalizados: {pedidosend}

                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid> */}

                    {/* Cuenta corriente */}

                    
                    
                    { (user.screensAccess && user.screensAccess.currentAcount) &&
                        <Grid item xs={12} sm={6}>
                            <Card className={classes.root}>
                                <CardActionArea onClick={() => changeView(1, 2)} >
                                    <CardContent>
                                        <AttachMoneyOutlined className={classes.iconStyles} ></AttachMoneyOutlined>
                                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        </Typography>
                                        <Typography style={{ fontSize: 20 }}>Cuenta corriente</Typography>
                                        <Typography variant="body2" color="textSecondary" component="p">Saldo: $ {parseFloat(saldo).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</Typography>
                                        <Typography variant="body2" color="textSecondary" component="p"> Atraso: {atraso} días</Typography>
                                    </CardContent>

                                </CardActionArea>
                            </Card>
                        </Grid>
                    }


                    {/* Aviso de pago */}

                    {(user.screensAccess && user.screensAccess.paymentNotice) &&
                        <Grid item xs={12} sm={6}>
                            <Card className={classes.root}>
                                <CardActionArea
                                    onClick={() => changeView(2, 2)}
                                >
                                    <CardContent>
                                        <DescriptionOutlined className={classes.iconStyles} ></DescriptionOutlined>
                                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        </Typography>
                                        <Typography style={{ fontSize: 20 }}>
                                            Aviso de pago
                                        </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                    &nbsp;
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary" component="p">
                                            &nbsp;
                                        </Typography>
                                    </CardContent>

                                </CardActionArea>
                            </Card>
                        </Grid>
                    }

                    {/* <Grid item xs={12} sm={6}>
                        <Card className={classes.root}>
                            <CardActionArea
                                onClick={() => changeView(3, 2)}
                            >
                                <CardContent>
                                    <InfoOutlined className={classes.iconStyles} ></InfoOutlined>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                    </Typography>
                                    <Typography style={{ fontSize: 20 }}>
                                        Catálogo
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        &nbsp;
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        &nbsp;
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid> */}

                    {(user.screensAccess && user.screensAccess.priceList) &&
                        <Grid item xs={12} sm={6}>
                        <Card className={classes.root}>
                            <CardActionArea
                                onClick={() => changeView(7, 2)}
                            >
                                <CardContent>
                                    <AssignmentOutlinedIcon style={{ fontSize: 40, color: "#0f5591" }} ></AssignmentOutlinedIcon>
                                    {/* <InfoOutlined className={classes.iconStyles} ></InfoOutlined> */}
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                    </Typography>
                                    <Typography style={{ fontSize: 20 }}>
                                        Lista de precios
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        &nbsp;
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        &nbsp;
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                        </Grid>
                    }

                   

                </Grid>
            </Grid>
            </div>
            </Container>
        </div>
       
    )
}
export default Nav2;
